import React, { ChangeEvent, useEffect, useState, useRef } from 'react'
import { BlockType, LinkItemType } from '../../containers/LessonPage/types'
import { Modal } from 'react-responsive-modal'
import isUrl from 'validator/lib/isURL'
import * as blockActions from '../../containers/AdminBlockEditPage/actions'
import { useDispatch } from 'react-redux'
import usePrevious from '../../hooks/usePrevious'

// Styles
import './styles.scss'

// Images
import IconLink from './images/iconLink'

// Modal styles
const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 400,
    borderRadius: 20,
    padding: 20,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

export default ({
  block,
  links,
}: {
  block: BlockType
  links: LinkItemType[]
}) => {
  const [selectedLinkId, setSelectedLinkId] = useState<string>('')
  const [modalCreate, setModalCreate] = useState<boolean>(false)
  const [title, setTitle] = useState<string>('')
  const [url, setUrl] = useState<string>('')

  const hasCreate = useRef<boolean>(false)

  const dispatch = useDispatch()

  const prevLinks = usePrevious(links)

  useEffect(() => {
    if (links !== prevLinks && prevLinks && hasCreate.current) {
      const lastAddedLinkId =
        links.find(
          newLink =>
            !prevLinks.find(prevLink => prevLink.link_id === newLink.link_id)
        )?.link_id || ''
      setSelectedLinkId(lastAddedLinkId)
    }
  }, [links, prevLinks])

  useEffect(() => {
    if (modalCreate && !hasCreate.current) {
      hasCreate.current = true
    }
  }, [modalCreate])

  const handleSelectLink = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    if (value === 'create-link') {
      setTitle('')
      setUrl('')
      setModalCreate(true)
    } else {
      setSelectedLinkId(value)
    }
  }

  const handleCreateLink = () => {
    dispatch(blockActions.createLink({ title, url }))
    setModalCreate(false)
  }

  const handleAssignLink = () => {
    const linksIds = block.links?.links
      ? [...block.links.links.map(link => link.link_id)]
      : []
    dispatch(
      blockActions.assignLinksToBlock(
        block.block_id,
        block.links?.block_link_id,
        [...linksIds, selectedLinkId]
      )
    )
    setSelectedLinkId('')
  }

  const handleRemoveLink = (link_id: string) => {
    const linksIds = block.links?.links
      ? [
          ...block.links.links
            .filter(link => link.link_id !== link_id)
            .map(link => link.link_id),
        ]
      : []
    dispatch(
      blockActions.assignLinksToBlock(
        block.block_id,
        block.links?.block_link_id,
        linksIds
      )
    )
  }

  return (
    <div className={'admin-links-block'}>
      <h2>Ссылки:</h2>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <td>
              <b>Название ссылки</b>
            </td>
            <td width={100} />
          </tr>
        </thead>
        <tbody>
          {block.links?.links && block.links.links.length ? (
            block.links.links.map(link => (
              <tr key={link.link_id}>
                <td style={{ display: 'flex', flexDirection: 'row' }}>
                  {link.title}{' '}
                  <a
                    style={{
                      display: 'inline-block',
                      marginLeft: 5,
                    }}
                    href={link.url}
                    target={'_blank'}
                    rel="noreferrer"
                  >
                    <IconLink />
                  </a>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <button onClick={() => handleRemoveLink(link.link_id)}>
                    Удалить
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td style={{ textAlign: 'center' }} colSpan={2}>
                <b>Нет добавленных ссылок!</b>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className={'admin-links-block__selector'}>
        <select value={selectedLinkId} onChange={handleSelectLink}>
          <option value={''} disabled={true}>
            ---
          </option>
          {links
            .filter(link => {
              if (block.links) {
                const findLink = block.links.links.find(
                  find => find.link_id === link.link_id
                )
                return !findLink
              }
              return true
            })
            .map(link => (
              <option key={link.link_id} value={link.link_id}>
                {link.title}
              </option>
            ))}
          <option value={'create-link'}>Создать новую ссылку</option>
        </select>
        <button disabled={!selectedLinkId} onClick={handleAssignLink}>
          Добавить ссылку
        </button>
      </div>
      <Modal
        open={modalCreate}
        styles={customModalStyles}
        onClose={() => setModalCreate(false)}
        center={true}
      >
        <h3 style={{ margin: 0, marginBottom: 10 }}>Создать новую ссылку</h3>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor={'title'}>Заголовок</label>
          <input
            style={{ margin: '0 0 10px', outline: 0 }}
            id={'title'}
            type={'text'}
            placeholder={''}
            autoComplete={'off'}
            value={title}
            onChange={event => setTitle(event.target.value)}
          />
          <label htmlFor={'link'}>Ссылка</label>
          <input
            style={{ margin: '0 0 15px', outline: 0 }}
            id={'link'}
            type={'text'}
            placeholder={''}
            autoComplete={'off'}
            value={url}
            onChange={event => setUrl(event.target.value)}
          />
          <button
            onClick={handleCreateLink}
            disabled={!isUrl(url) || !title}
            style={{ cursor: 'pointer' }}
          >
            Создать новую ссылку
          </button>
        </div>
      </Modal>
    </div>
  )
}
